export default "__VITE_ASSET__DfztK61q__"